import React, { useState } from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import stylesQuestionario from './Questionario.module.scss';
import Domanda from '../../../components/Domanda/Domanda';
import { Form, Modal, Button, Spin } from 'antd';
import * as actionTypes from '../../../redux/actions/actionTypes';
import { useSelector, useDispatch } from 'react-redux';
import salvaStep from '../../../redux/actions/mock/salvaStep';
import getCalcoloPreventivo from '../../../redux/actions/mock/getCalcoloPreventivo';
import Immagine from '../../../components/Immagine/Immagine';

const Questionario = props => {
  const [domandaAttuale, setDomandaAttuale] = useState(1);
  const [visibleModalAssicurazione, setVisibleModalAssicurazione] =
    useState(false);
  const datiState = useSelector(state => state.dataReducer);
  const datiPreventivo = useSelector(
    state => state.dataReducer.modello.datiPratica
  );
  const apiPath = datiState.dataApiPath;
  const numPratica = datiState.modello.numPratica;
  const loadingStep = datiState.load.loadingStep;
  const dispatch = useDispatch();

  function openModalCancellazioneAssicurazione() {
    console.log(visibleModalAssicurazione);
    setVisibleModalAssicurazione(!visibleModalAssicurazione);
  }

  async function funcCambioDomanda(e) {
    let sceltaDomanda = e.target.value;
    if (sceltaDomanda === true) {
      if (domandaAttuale < 3) {
        await sleep(400);
        await dispatch({
          type: actionTypes.SALVA_DOMANDA_QUESTIONARIO,
          numeroDomanda: e.target.name,
          valoreDomanda: e.target.value,
        });
        await setDomandaAttuale(domandaAttuale + 1);
      } else {
        await sleep(400);
        await dispatch({
          type: actionTypes.SALVA_DOMANDA_QUESTIONARIO,
          numeroDomanda: e.target.name,
          valoreDomanda: e.target.value,
        });
        await dispatch({ type: actionTypes.SALVA_QUESTIONARIO });
        await dispatch({ type: actionTypes.LOADING_TRUE });
        await dispatch(
          salvaStep(
            datiState.modello.datiPratica,
            datiState.modello.id,
            datiState.modello.codiceBroker,
            datiState.modello.currentStep,
            apiPath,
            numPratica
          )
        );
      }
    } else {
      setVisibleModalAssicurazione(!visibleModalAssicurazione);
    }
  }

  function TornaAlQuestionario() {
    setVisibleModalAssicurazione(!visibleModalAssicurazione);
  }

  async function procediAlRiepilogo() {
    await dispatch({ type: actionTypes.REMOVE_ASSICURAZIONE, payload: false });
    await dispatch({
      type: actionTypes.SALVA_QUESTIONARIO,
      numeroStep: 'step11',
    });
    await dispatch({ type: actionTypes.LOADING_TRUE });
    await dispatch(
      getCalcoloPreventivo(
        datiPreventivo.importo,
        datiPreventivo.numeroRate,
        datiPreventivo.progetto,
        datiPreventivo.assicurazione,
        datiState.modello.codiceBroker,
        apiPath
      )
    );
    await setTimeout(
      () =>
        dispatch(
          salvaStep(
            datiState.modello.datiPratica,
            datiState.modello.id,
            datiState.modello.codiceBroker,
            datiState.modello.currentStep,
            apiPath,
            numPratica
          )
        ),
      10000
    );
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  return (
    <div className={stylesForm.Form}>
      <HeaderStep titolo="Questionario di adeguatezza" sottotitolo="" />

      <Modal
        onCancel={openModalCancellazioneAssicurazione}
        open={true}
        closeIcon={<Immagine urlImage={'close-modal.svg'} name="close" />}>
        <Spin spinning={loadingStep}>
          <Form name="step11" initialValues={props.datiIniziali}>
            <Domanda
              nameDomanda="domanda1"
              domandaAttuale={domandaAttuale}
              cambioDomanda={funcCambioDomanda}
              numeroDomanda="1"
              testoDomanda="Vuoi proteggere te e la tua famiglia in caso di eventi che possono rendere più difficile pagare il finanziamento?"
            />
            <Domanda
              nameDomanda="domanda2"
              domandaAttuale={domandaAttuale}
              cambioDomanda={funcCambioDomanda}
              numeroDomanda="2"
              testoDomanda="Vuoi acquistare un’assicurazione che ti protegge in caso di decesso o gravi malattie, anche se hai già acquistato una polizza a copertura dei medesimi rischi?"
            />
            <Domanda
              nameDomanda="domanda3"
              domandaAttuale={domandaAttuale}
              cambioDomanda={funcCambioDomanda}
              numeroDomanda="3"
              testoDomanda="Confermi di non essere portatore di invalidità/inabilità permanente superiore al 33% riconosciuta da INPS, INAIL o altro ente pubblico preposto?"
            />
            {/* <Domanda nameDomanda='domanda4' domandaAttuale={domandaAttuale} cambioDomanda={funcCambioDomanda}numeroDomanda='4' testoDomanda='Confermi di non essere titolare di una pensione di invalidità e/o inabilità e di non aver presentato domanda per ottenerla?' /> */}
          </Form>
        </Spin>
      </Modal>

      <Modal
        open={visibleModalAssicurazione}
        closeIcon={<Immagine urlImage={'close-modal.svg'} name="close" />}>
        <Spin spinning={loadingStep}>
          <h2 className={stylesQuestionario.headerModale}>Attenzione!</h2>
          <p className={stylesQuestionario.paragrafoModale}>
            In base alla risposte fornite, la proposta assicurativa non risulta
            adeguata alle tue esigenze assicurative.
          </p>
          <div className={stylesQuestionario.divBottoni}>
            <Button
              onClick={TornaAlQuestionario}
              className={stylesQuestionario.BottoneIndietro}>
              Torna al questionario
            </Button>
            <Button
              onClick={procediAlRiepilogo}
              className={stylesQuestionario.BottoneAvanti}>
              Procedi senza assicurazione
            </Button>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default Questionario;
